import MonitorHeartIcon from '@mui/icons-material/MonitorHeart'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import MedicationIcon from '@mui/icons-material/Medication'
import GroupsIcon from '@mui/icons-material/Groups'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import GavelIcon from '@mui/icons-material/Gavel'
import CelebrationIcon from '@mui/icons-material/Celebration'
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle'
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism'
import PaidIcon from '@mui/icons-material/Paid'

// Single source of truth for section navigation. Slugs must match the server's
// section slugs in server/src/routers/governance/kpi/index.js.
const KPI_SECTIONS = [
  {
    slug: 'clinical-records',
    name: 'Clinical Records',
    icon: MonitorHeartIcon,
    color: '#268EBB',
    blurb: 'Response times, record quality, outcomes, and cardiac arrest',
  },
  {
    slug: 'incidents',
    name: 'Patient Safety & Incidents',
    icon: HealthAndSafetyIcon,
    color: '#E32525',
    blurb: 'Incidents, safeguarding, and health & safety concerns',
  },
  {
    slug: 'medicines',
    name: 'Medicines Management',
    icon: MedicationIcon,
    color: '#85276A',
    blurb: 'Administrations, medicine audits, and controlled drugs',
  },
  {
    slug: 'workforce',
    name: 'Workforce & HR',
    icon: GroupsIcon,
    color: '#1F3D7C',
    blurb: 'Shifts, training, DBS, registrations, and appraisals',
  },
  {
    slug: 'fleet',
    name: 'Fleet & Equipment',
    icon: LocalShippingIcon,
    color: '#F28B1F',
    blurb: 'Vehicle availability, checks, defects, and stock',
  },
  {
    slug: 'governance',
    name: 'Clinical Governance',
    icon: GavelIcon,
    color: '#00964C',
    blurb: 'Risk register, actions, PGDs, and announcements',
  },
  {
    slug: 'events',
    name: 'Events',
    icon: CelebrationIcon,
    color: '#CCA43B',
    blurb: 'Event planning, staffing, delivery, and invoicing',
  },
  {
    slug: 'pts',
    name: 'Patient Transport',
    icon: AirportShuttleIcon,
    color: '#268EBB',
    blurb: 'Journey reliability, punctuality, and efficiency',
  },
  {
    slug: 'patient-experience',
    name: 'Patient Experience',
    icon: VolunteerActivismIcon,
    color: '#85276A',
    blurb: 'Friends & Family Test, feedback, and complaints',
  },
  {
    slug: 'finance',
    name: 'Finance',
    icon: PaidIcon,
    color: '#00964C',
    blurb: 'Revenue, event costs, margin, and outstanding debtors',
  },
]

export default KPI_SECTIONS
